import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { Select } from '../../select';
import { navSelector } from 'store/modules/competition-nav/selectors/nav-selector';
import { getTranslation } from '../../../utils/translations';
import { useSiteSettings } from 'common/react/hooks/use-site-settings';
import { setNavItem } from 'common/store/modules/competition-nav/init';

export const LocationNavItem = ({ locations }) => {
    const dispatch = useDispatch();
    const nav = useSelector(navSelector);
    const { setSiteSettings, settingsConfig } = useSiteSettings();

    const initialLocation = useMemo(() => {
        return locations?.find((l) => l.value === nav.location.location);
    }, [nav.location, locations]);

    return (
        <div className="stats-leaders-nav__select competition-nav__competition-select">
            <Select
                items={locations}
                itemToString={(location) => location?.value}
                type="with-default"
                icon="globe"
                initialSelectedItem={initialLocation?.value}
                activeItem={initialLocation}
                label={getTranslation('label.filters.location')}
                onSelectedItemChange={({ selectedItem }) => {
                    const newRegion = {
                        timezone: selectedItem.extra.timezone,
                        id: selectedItem.extra.id,
                        name: selectedItem.extra.name,
                        location: selectedItem.value
                    };
                    dispatch(
                        setNavItem({
                            navItem: 'location',
                            value: newRegion
                        })
                    );
                    setSiteSettings({
                        [settingsConfig.region.key]: newRegion
                    });
                }}
                hideLabel
            />
        </div>
    );
};

LocationNavItem.propTypes = {
    locations: PropTypes.array,
    title: PropTypes.string
};
